import React from "react";
import {
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const InstagramConnectionGuide = () => {
  return (
    <div className="card-modern p-6 mt-6 mb-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-full bg-primary-100 dark:bg-primary-900/30 flex items-center justify-center">
          <InfoIcon className="text-primary-600 dark:text-primary-400" />
        </div>
        <Typography variant="h6" className="text-xl font-bold text-gray-900 dark:text-white">
          Why do I need to connect Instagram to Facebook?
        </Typography>
      </div>

      <Typography
        variant="body1"
        className="text-base text-gray-700 dark:text-gray-300 mb-6 leading-relaxed"
      >
        Meta (Facebook) requires that Instagram Business accounts be connected
        to a Facebook Page to use third-party tools like ReelTale. This is a
        security requirement, not something we control.
      </Typography>

      <Typography
        variant="h6"
        className="text-lg font-bold text-gray-900 dark:text-white mb-4"
      >
        How to connect your Instagram to Facebook:
      </Typography>

      <List className="space-y-2">
        <ListItem className="pl-0">
          <ListItemIcon className="min-w-0 mr-4">
            <CheckCircleIcon className="text-primary-600 dark:text-primary-400" />
          </ListItemIcon>
          <ListItemText
            primary={<span className="text-gray-900 dark:text-white font-semibold">Step 1: Go to your Instagram app</span>}
            secondary={<span className="text-gray-600 dark:text-gray-400">Open Instagram on your phone or desktop</span>}
          />
        </ListItem>
        <ListItem className="pl-0">
          <ListItemIcon className="min-w-0 mr-4">
            <CheckCircleIcon className="text-primary-600 dark:text-primary-400" />
          </ListItemIcon>
          <ListItemText
            primary={<span className="text-gray-900 dark:text-white font-semibold">Step 2: Switch to Professional Account</span>}
            secondary={<span className="text-gray-600 dark:text-gray-400">Go to Settings → Account → Switch to Professional Account</span>}
          />
        </ListItem>
        <ListItem className="pl-0">
          <ListItemIcon className="min-w-0 mr-4">
            <CheckCircleIcon className="text-primary-600 dark:text-primary-400" />
          </ListItemIcon>
          <ListItemText
            primary={<span className="text-gray-900 dark:text-white font-semibold">Step 3: Connect to Facebook Page</span>}
            secondary={<span className="text-gray-600 dark:text-gray-400">Choose 'Business' account type and connect to your Facebook Page</span>}
          />
        </ListItem>
        <ListItem className="pl-0">
          <ListItemIcon className="min-w-0 mr-4">
            <CheckCircleIcon className="text-primary-600 dark:text-primary-400" />
          </ListItemIcon>
          <ListItemText
            primary={<span className="text-gray-900 dark:text-white font-semibold">Step 4: Come back here</span>}
            secondary={<span className="text-gray-600 dark:text-gray-400">Once connected, refresh this page and select your Instagram page from the dropdown above</span>}
          />
        </ListItem>
      </List>

      <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-xl">
        <Typography
          variant="body2"
          className="text-blue-800 dark:text-blue-200"
        >
          <strong>Don't have a Facebook Page?</strong> You can create one for
          free in just a few minutes. This is just a technical requirement -
          you don't need to actively use the Facebook Page.
        </Typography>
      </div>
    </div>
  );
};

export default InstagramConnectionGuide;
